import React, { useState, useEffect } from 'react';

const ConsentModal = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('site_consent');
        if (!consent) {
            setShow(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('site_consent', 'true');
        setShow(false);
    };

    if (!show) return null;

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <h3>🍪 We use cookies</h3>
                <p>To improve your learning journey on ARIVUNEST and save your progress, we use cookies and local storage.</p>
                <div style={styles.buttons}>
                    <button onClick={handleAccept} style={styles.btnAccept}>Accept & Continue</button>
                    <button onClick={() => setShow(false)} style={styles.btnDecline}>Decline</button>
                </div>
            </div>
        </div>
    );
};

const styles = {
    overlay: {
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 9999,
        maxWidth: '350px',
        width: '100%'
    },
    modal: {
        background: 'white',
        padding: '24px',
        borderRadius: '16px',
        boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
        border: '1px solid #e5e7eb'
    },
    buttons: {
        display: 'flex',
        gap: '10px',
        marginTop: '16px'
    },
    btnAccept: {
        flex: 1,
        padding: '8px 16px',
        background: '#0056D2',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontWeight: '600',
        cursor: 'pointer'
    },
    btnDecline: {
        padding: '8px 16px',
        background: 'transparent',
        color: '#6b7280',
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
        cursor: 'pointer'
    }
};

export default ConsentModal;
